import { render, staticRenderFns } from "./KbvBISTable.vue?vue&type=template&id=5bde8bfa&scoped=true"
import script from "./KbvBISTable.vue?vue&type=script&lang=js"
export * from "./KbvBISTable.vue?vue&type=script&lang=js"
import style0 from "./KbvBISTable.vue?vue&type=style&index=0&id=5bde8bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde8bfa",
  null
  
)

export default component.exports